module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.8d987d62.svg";